import { useViewport } from '../../../../../hooks/useViewport';

export interface PhotoLayout {
  phone: boolean;
  /** Width of the photo column when there is room for two columns. */
  leadWidth: number;
  buttonHeight: number;
}

const LEAD_WIDTH = { tablet: 300, desktop: 340 } as const;
const BUTTON_HEIGHT = { phone: 44, other: 30 } as const;

/** Phones stack everything with tall buttons; tablets get a narrower photo column than desktops. */
export function usePhotoLayout(): PhotoLayout {
  const { isPhone, isDesktop } = useViewport();
  return {
    phone: isPhone,
    leadWidth: isDesktop ? LEAD_WIDTH.desktop : LEAD_WIDTH.tablet,
    buttonHeight: isPhone ? BUTTON_HEIGHT.phone : BUTTON_HEIGHT.other,
  };
}
